// extracted by mini-css-extract-plugin
export default {"footerMenuLink":"footerMenuLink_footerMenuLink__y4GKJ","focus-visible":"footerMenuLink_focus-visible__BQToO"};